import { Injectable, signal } from '@angular/core';

export enum NotificationType {
  holidays = 'Holidays',
  systems = 'Notifications',
}

@Injectable({
  providedIn: 'root',
})
export class NotificationsPanelService {
  private openNotificationsSignal = signal<NotificationType | null>(null);
  public openNotifications = this.openNotificationsSignal.asReadonly();

  public onOpenNotifications(open: NotificationType | null): void {
    this.openNotificationsSignal.set(open);
  }
}
